import { Component, ErrorInfo, ReactNode } from 'react';
import { RefreshCw } from 'lucide-react';

interface Props { children: ReactNode; }
interface State { hasError: boolean; error: Error | null; }

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render(): ReactNode {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        className="min-h-screen flex items-center justify-center p-8"
        style={{ background: 'var(--bg)' }}
      >
        <div
          className="rounded-lg border p-8 max-w-sm w-full text-center"
          style={{ background: 'var(--bg-panel)', borderColor: 'var(--border)' }}
        >
          <div className="text-2xl mb-4">⚠</div>
          <h1 className="text-sm font-semibold mb-2" style={{ color: 'var(--text-1)' }}>
            Something went wrong
          </h1>
          {this.state.error && (
            <p className="text-xs font-mono mb-5 p-2 rounded" style={{ background: 'var(--bg-subtle)', color: 'var(--red)' }}>
              {this.state.error.message}
            </p>
          )}
          <button
            onClick={() => window.location.reload()}
            className="flex items-center gap-2 mx-auto px-4 py-2 text-xs rounded transition-opacity hover:opacity-80"
            style={{ background: 'var(--accent)', color: '#fff' }}
          >
            <RefreshCw size={12} /> Reload
          </button>
        </div>
      </div>
    );
  }
}
